import React from 'react';
import { Button, Card, Container, Form, Modal, Row } from 'react-bootstrap';

interface Props {
  t: any,
  showModal: boolean,
  closeModal: () => void,
  validated: boolean,
  handleSubmit: (event: any) => void,
  newMail: string,
  onChangeValue: (e: React.ChangeEvent<HTMLInputElement>) => void,
}

const ChangeMailModal = (props: Props) => {
  console.log('MODAL 4');
  return (
        <>
        <Modal show={props.showModal} backdrop={true} keyboard={true} size='xl' onHide={props.closeModal}>
          <Modal.Header>
            <Modal.Title>{props.t('CHANGE_MAIL')}</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Container>
              <Row className='w-100 justify-content-center'>
                <Card className='col-md-7 p-0'>
                  <Form noValidate validated={props.validated} onSubmit={props.handleSubmit}>
                    <Card.Header>{props.t('CHANGE_MAIL_SENSOR')}</Card.Header>
                    <Card.Body>
                      <Form.Group controlId='newMail'>
                        <Form.Label>{props.t('NEW_MAIL')}</Form.Label>
                        <Form.Control required={true} type='text' placeholder={props.t('NEW_MAIL')}
                          value={props.newMail} onChange={props.onChangeValue} />
                      </Form.Group>
                    </Card.Body>
                    <Card.Footer>
                      <Button type='submit'>{props.t('CHANGE')}</Button>
                    </Card.Footer>
                  </Form>
                </Card>
              </Row>
            </Container>
          </Modal.Body>
        </Modal>
        </>
  );
};

export default ChangeMailModal;